export const mobileLandscapeBreakpoint = 568;
export const tabletsPortraitBreakpoint = 867;
export const tabletsLandscapeBreakpoint = 1024;
export const laptopsBreakpoint = 1200;

export const breakpointForJobsList = 950;
export const breakpointForEmployerHeader = 985;
